import { render, staticRenderFns } from "./RecordsList.vue?vue&type=template&id=ccca1146&scoped=true&"
import script from "./RecordsList.vue?vue&type=script&lang=js&"
export * from "./RecordsList.vue?vue&type=script&lang=js&"
import style0 from "./RecordsList.vue?vue&type=style&index=0&id=ccca1146&lang=scss&scoped=true&"
import style1 from "./RecordsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccca1146",
  null
  
)

export default component.exports